module.exports = __webpack_public_path__ + "static/media/Hbook-20.a8eb517b.jpg";